import { lazy } from 'react';

export const DefaultDashboardLazy = lazy(() => import('./DefaultDashboard'));
